module.exports = __webpack_public_path__ + "static/media/smart_service_1_EN.35145fb9.png";